import { PrinterOutlined } from '@ant-design/icons';
import { ReactComponent as NextArrowIcon } from '@Icons/additional/arrow-left.svg';

import styles from './header-mobile.module.css';

interface RenderHeaderMobileProps {
  onCancel: () => void;
  handleBack?: () => void;
  headerCaption: string;
}

const RenderHeaderMobile: React.FC<RenderHeaderMobileProps> = ({
  handleBack,
  headerCaption,
}) => {
  return (
    <div className={styles.header}>
      <NextArrowIcon onClick={handleBack} />
      <span>{headerCaption}</span>
      <PrinterOutlined />
    </div>
  );
};

export default RenderHeaderMobile;
